import type { PropsWithChildren } from 'react';

import { FullscreenImageLayout, Stack } from '@drycut/ui-components';

export function Layout({ children }: PropsWithChildren): React.ReactElement {
  return (
    <FullscreenImageLayout src="/images/manual-booking-bg.jpg">
      <Stack className="justify-center items-center grow">{children}</Stack>
    </FullscreenImageLayout>
  );
}
